import { SuggestedVisualizations } from 'models/ai-chat/ai-chat-response';
import React from 'react';
import { FaLightbulb, FaChartBar } from 'react-icons/fa';


interface SuggestionsProps {
  suggestions: string[];
  suggestedVisualizations?: SuggestedVisualizations[] | null;
  suggestionText?: string;
  onSuggestionClick: (suggestion: string) => void;
  onVisualizationClick?: (visualizationType: string, description: string) => void;
}

const Suggestions: React.FC<SuggestionsProps> = ({ 
  suggestions, 
  suggestedVisualizations = [], 
  onSuggestionClick,
  onVisualizationClick 
}) => {

  const hasSuggestions = suggestions && suggestions.length > 0;
  const hasVisualizations = suggestedVisualizations && suggestedVisualizations.length > 0;
  
  if (!hasSuggestions && !hasVisualizations) return null;

  const buttonBaseClass = `px-3 py-1.5 text-sm rounded-md transition-colors flex items-center`;
  const buttonStyleClass =  'bg-secondary-background hover:bg-tertiary-background border text-left';
  
  return (
    <div className="my-4 space-y-3">
      {hasSuggestions && (
        <div>

          <div className="flex flex-wrap gap-2">
            {suggestions.slice(0,1).map((suggestion, index) => (

               <button
                key={`q-${index}`}
                onClick={() => onSuggestionClick(suggestion)}
                className={`${buttonBaseClass} ${buttonStyleClass}`}
              >
              <FaLightbulb className="mr-2" />  {suggestion}
              </button>
   
            
            ))}
          </div>
        </div>
      )}
      
      {hasVisualizations && (
        <div>
          <div className="flex flex-wrap gap-2">
            {suggestedVisualizations && suggestedVisualizations.map((viz, index) => (
              <button
                key={`v-${index}`}
                onClick={() => onVisualizationClick?.(viz.type || 'default', viz.description)}
                className={`${buttonBaseClass} ${buttonStyleClass}`}
                title={viz.description}
              >
                <FaChartBar className="mr-1.5" />
                {viz.type && viz.description.includes(viz.type)
                  ? <span>{viz.description}</span> :
                <span>{viz.description} in a {viz.type}</span>
                }
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default Suggestions;